export default __webpack_public_path__ + "static/img-nhs-process--mobile-2091546f3565079b95303e27513d6088.png";